import { BaseModel } from './base-model';

export class Purities extends BaseModel {
	idPurity: number;
	valueRateInvoiceDetailPurity: number;
}
